import * as React from "react";
const SvgWrite = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.624 18.238a.75.75 0 0 1-.274-1.024l.625-1.083-.217-.125a.75.75 0 0 1-.36-.8l.634-3.098a.75.75 0 0 1 .086-.225l6.5-11.258a.75.75 0 0 1 1.024-.274l3.464 2a.75.75 0 0 1 .275 1.024l-6.5 11.258a.75.75 0 0 1-.152.187l-2.366 2.098a.75.75 0 0 1-.873.088l-.216-.125-.625 1.083a.75.75 0 0 1-1.025.274Zm2.148-2.801 1.183-1.05-1.662-.959-.317 1.55.398.229.398.23Zm.02-3.453 2.165 1.25 5.75-9.96-2.165-1.25-5.75 9.96ZM.518 23c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75v-5.042a.75.75 0 0 0-1.5 0v4.292h-14.5V3.75h11.937a.75.75 0 1 0 0-1.5H1.268a.75.75 0 0 0-.75.75v20Zm7.75-9.25a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0 0 1.5h3.5Zm-3.5-4.5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm7.5-3h-7.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgWrite;
